import { render, staticRenderFns } from "./visual-identity.vue?vue&type=template&id=5f6e8ff3&scoped=true&"
import script from "./visual-identity.vue?vue&type=script&lang=js&"
export * from "./visual-identity.vue?vue&type=script&lang=js&"
import style0 from "./visual-identity.vue?vue&type=style&index=0&id=5f6e8ff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e8ff3",
  null
  
)

export default component.exports